import React from 'react';
import UnifiedMessages from './UnifiedMessages';

/**
 * TalentMessagesCenter — PO-2026-06 unified talent inbox.
 * All talent communication (iEvntür Support + Event Channels) lives here,
 * with All Messages as the default view.
 */
const TalentMessagesCenter = () => <UnifiedMessages />;

export default TalentMessagesCenter;
